var inputf = document.querySelector("#embroidery-field");
var displayd = document.querySelectorAll(".text-div");
var txtdiv = document.querySelectorAll(".text-div-m");

// Top-level so both the tap handler and input listener can call it
function killPulse() {
  document.querySelectorAll('.text-div').forEach(function(el) {
    el.classList.add('has-input');
  });
  sessionStorage.setItem('cn-pulse-seen', '1');
}
var colorsinp = document.querySelectorAll(".col-i");
var outcolorsinp = document.querySelectorAll(".out-c");
var nocustmbtn = document.querySelector("#no-emb-btn");
var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var isHidden;
if (isSafari) {
  txtdiv.forEach(function (ele) {
    ele.style.fontWeight = "700";
  });
}
const mediaQuery = window.matchMedia("(max-width:750px)");
function handleMediaQueryChange(event) {
  if (event.matches) {
    document.addEventListener("DOMContentLoaded", function () {
      sliderbtns();
    });
  }
}
handleMediaQueryChange(mediaQuery);

colorsinp.forEach(function (element) {
  element.addEventListener("click", function () {
    var colorvalue = element.nextElementSibling.style.backgroundColor;
    console.log(colorvalue);
    txtdiv.forEach(function (ele) {
      ele.style.color = colorvalue;
    });
  });
});

outcolorsinp.forEach(function (element) {
  element.addEventListener("click", function () {
    var outvalue = element.nextElementSibling.style.backgroundColor;

    txtdiv.forEach(function (ele) {
      ele.style.webkitTextStrokeColor = outvalue;
      if (isSafari) ele.style.fontWeight = "700";
    });
  });
});

if (inputf) {
  inputf.addEventListener("input", function (e) {
    showdiv();
    if (inputf.value.trim().length > 0) killPulse();
  });
}
if (nocustmbtn){

nocustmbtn.addEventListener("click", function () {
  if (isHidden) {
    displayd.forEach(function (ele) {
      ele.style.display = "block";
    });

    isHidden = false;
  } else {
    displayd.forEach(function (ele) {
      ele.style.display = "none";
    });

    txtdiv.forEach(function (ele) {
      ele.style.webkitTextStrokeColor = "black";
      //   ele.style.textShadow=`2px 0px black, -2px 0px black,
      //         1px -2px black, 2px -2px black,
      //         2px 2px black, -2px 2px black,
      //         -2px -2px black`;
      ele.style.color = "black";
    });

    isHidden = true;
  }
});
  
}

// var allthumbs=document.querySelectorAll(".Color_name_ofoption");
// allthumbs.forEach(function(element){
//   element.addEventListener('click',function () {
//     var attvalue=element.getAttribute("data-alt");
//     if (attvalue == "main-img"){
//        displayd.style.display = 'none';
//       setTimeout(function() {
//     displayd.style.display = 'block';
//      },500);
//     }
//     else{
//        displayd.style.display = 'none';
//     };

//   });
// });

var swatches = document.querySelectorAll(".Color_name_ofoption");
swatches.forEach(function (element) {
  element.addEventListener("click", function () {
    displayd.forEach(function (el) {
      el.style.display = "none";
    });

    if (
      document.getElementById("embroidery-switch") &&
      document.getElementById("embroidery-switch").checked
    ) {
      displayd.forEach(function (ele) {
        setTimeout(function () {
          ele.style.display = "block";
        }, 500);
      });
    }
    if (element.dataset.ls_img_url) {
      document.querySelectorAll(".gallery_switcher img").forEach((switcher) => {
        switcher.src = element.dataset.ls_img_url;
        if (element.dataset.ls_img_id)
          switcher.parentElement.dataset.img_id = element.dataset.ls_img_id;
        console.log(switcher.parentElement.dataset.img_id);
      });
    }
  });
  // element.addEventListener('mouseenter',e=>{
  //   e.currentTarget.querySelector('label').click();
  // })
});

function sliderbtns() {
  var sliderbtns = document.querySelectorAll(".slick-arrow");

  sliderbtns.forEach(function (element) {
    element.addEventListener("click", function (e) {
      e.preventDefault();

      checkmainclass();
    });
  });
}

function checkmainclass() {
  var mainthumbs = document.querySelector(
    ".swatch-color-main .slick-slide.slick-active"
  );
  if (mainthumbs != null) {
    var nextthumb = mainthumbs.nextElementSibling.getAttribute(
      "attached-to-variant"
    );

    console.log(nextthumb);
    if (nextthumb == "true") {
      displayd.forEach(function (ele) {
        ele.style.display = "none";
      });

      setTimeout(function () {
        displayd.forEach(function (ele) {
          ele.style.display = "block";
        });
      }, 500);
    } else {
      displayd.forEach(function (ele) {
        ele.style.display = "none";
      });
    }
  } else {
    var mainthumbs = document.querySelector(".slick-slide.slick-current");
if (!mainthumbs) return; // slick hasn't initialized yet
var nextthumb = mainthumbs.getAttribute("attached-to-variant");
console.log(nextthumb);

    if (nextthumb == "true") {
      displayd.forEach(function (ele) {
        ele.style.display = "none";
      });
      setTimeout(function () {
        displayd.forEach(function (ele) {
          ele.style.display = "block";
        });
      }, 500);
    } else {
      if (window.innerWidth < 750) {
        displayd.forEach(function (ele) {
          ele.style.display = "none";
        });
      }
    }
  }
}

// function showdiv() {
//   var imgValue = txtdiv[0].innerText;
//   var inputValue = inputf.value.trim();
  
//   // Replace "+" with "†"
//   if (inputValue.includes("+")) {
//     inputValue = inputValue.replace(/\+/g, "†");
//   }
//   console.log(inputValue);

//   // Get special symbols from body data attribute
//   var specialSymbols = $("body").data("special-symbols") || "";
  
//   // Include "†" as a special symbol
//   specialSymbols += "†"; 
//   var escapedSymbols = specialSymbols.replace(/[-\/\\^$.*+?()[\]{}|]/g, "\\$&");
  
//   // Regex for special characters only
//   var onlySpecialChars = new RegExp(`^[${escapedSymbols}]+$`).test(inputValue);
  
//   // Regex for alphanumeric characters only
//   var onlyLetters = /^[A-Z0-9]+$/.test(inputValue.toUpperCase());
  
//   // Regex for letters/numbers with special symbols intermixed
//   var lettersWithSpecial = new RegExp(`^[A-Z0-9${escapedSymbols}]+$`, 'i').test(inputValue);

//   if (onlySpecialChars || lettersWithSpecial || onlyLetters) {
//     var valinp = inputValue.toUpperCase();
//     txtdiv.forEach(function (ele) {
//       ele.innerText = valinp;
//     });
//   } else {
//     txtdiv.forEach(function (ele) {
//       console.log("value", imgValue);
//       if (inputValue !== "") {
//         ele.innerText = imgValue;
//       } else {
//         ele.innerText = "";
//       }
//       ele.style.fontFamily = "";
//     });
//   }
// }
function showdiv() {
  if (!txtdiv || !txtdiv.length) return;

  const imgValue = txtdiv[0].innerText;
  const allowEmoji = inputf.dataset.emoji === "true";
  console.log("allow", allowEmoji);

  let inputValue = (inputf.value || "").trim();

  // Replace "+" with "†"
  inputValue = inputValue.replace(/\+/g, "†");

  const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
  let isEmoji = false;
  if (allowEmoji) {
    // Build allowed-character class from theme setting (body[data-special-symbols])
    let specialSymbols = $("body").data("special-symbols") || "";
    specialSymbols += "†$";
    const escapedSymbols = specialSymbols.replace(/[-\/\\^$.*+?()[\]{}|]/g, "\\$&");
    inputValue = inputValue.replace(
      new RegExp(`[^A-Za-z0-9${escapedSymbols}\\p{Emoji_Presentation}\\p{Extended_Pictographic}\\p{Regional_Indicator}\\u200D\\uFE0F\\uFE0E]`, 'gu'),
      ''
    );
   isEmoji = /[\p{Emoji_Presentation}\p{Extended_Pictographic}\p{Regional_Indicator}]/u.test(inputValue);
  console.log(inputValue);
    
  } else {
    let specialSymbols = $("body").data("special-symbols") || "";
    specialSymbols += "†";

    const escapedSymbols = specialSymbols.replace(/[-\/\\^$.*+?()[\]{}|]/g, "\\$&");

    const onlySpecialChars = new RegExp(`^[${escapedSymbols}]+$`).test(inputValue);
    const onlyLetters = /^[A-Z0-9]+$/i.test(inputValue);
    const lettersWithSpecial = new RegExp(`^[A-Z0-9${escapedSymbols}]+$`, 'i').test(inputValue);

    if (!(onlySpecialChars || lettersWithSpecial || onlyLetters)) {
      restoreFallback(imgValue, inputValue);
      return;
    }
  }
  let valinp = '';
  if (!isEmoji){
   valinp = inputValue.toUpperCase();
   console.log("emoji",isEmoji );
  }
  else{
   valinp = inputValue;
  }

  // Cap to 1 grapheme for emoji, 2 chars for plain alphanumeric (matches input field's own cap)
  let isEmojiValue = /[\p{Extended_Pictographic}\p{Regional_Indicator}]/u.test(valinp);
  if (isEmojiValue) {
    try {
      const seg = new Intl.Segmenter(undefined, { granularity: "grapheme" });
      const graphemes = [...seg.segment(valinp)];
      if (graphemes.length > 1) valinp = graphemes[0].segment;
    } catch (e) {}
  } else if (valinp.length > 2) {
    valinp = valinp.slice(0, 2);
  }

  inputf.value = valinp;
  txtdiv.forEach(ele => {
    ele.innerText = valinp;
    if (isEmoji){
    ele.classList.add('noto-color-emoji-regular');
    inputf.setAttribute('readonly', true);
    }
    else{
      ele.classList.remove('noto-color-emoji-regular');
      inputf.removeAttribute('readonly');
    }
  });
}


function restoreFallback(imgValue, inputValue) {
  txtdiv.forEach(ele => {
    if (inputValue !== "") {
      ele.innerText = imgValue;
    } else {
      ele.innerText = "";
    }
    ele.style.fontFamily = "";
  });
}

/* Tap the number on the sleeve → focus field (keyboard opens) then scroll into view */
(function() {
  function bindTapToField() {
    var field = document.getElementById('embroidery-field');
    if (!field) return;

    // If already tapped this session, kill pulse immediately on load
    if (sessionStorage.getItem('cn-pulse-seen')) killPulse();

    document.querySelectorAll('.text-div').forEach(function(el) {
      el.addEventListener('click', function() {
        // Kill pulse immediately and permanently for this session
        killPulse();
        // focus() MUST be synchronous inside the tap gesture or mobile won't open keyboard
        field.focus();
        // Scroll after — keyboard is already opening
        field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTapToField);
  } else {
    bindTapToField();
  }
})();

/* Move title/stars/price under image column on desktop.
   Skipped on jacket PDP — jacket renders cst-desk-view above
   .product-single__meta in Liquid and shouldn't be moved. */
(function moveTitleUnderImages() {
  function doMove() {
    // Jacket PDP: do not move — Liquid already places cst-desk-view correctly.
    if (window.location.pathname.indexOf('custom-numbered-varsity-jacket') !== -1) return;
    if (window.innerWidth >= 750) {
      var deskView = document.getElementById('cst-desk-view');
      var imgCol = document.querySelector('.product-single__media-group');
      if (deskView && imgCol && deskView.parentElement !== imgCol) {
        imgCol.appendChild(deskView);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doMove);
  } else {
    doMove();
  }
})();

/* Mobile pinned Add-to-Cart bar with a 30% mini-mockup.
   Appears on mobile (<=750px) only when the embroidery field has a value AND the
   real ATC button has scrolled ABOVE the viewport; hides otherwise / when the
   side cart is open. Adds to cart by clicking the real button so existing
   validation (theme.js) and the side-cart submit flow (side-cart.js) both run. */
(function cnPinnedAtcBar() {
  var SCALE = 0.396; // mock size relative to the main mockup (fills the tray height); +10% to enlarge the mini-mockup and grow the bar

  function init() {
    var fieldEl = document.querySelector('#embroidery-field');
    var realBtn = document.querySelector('form.product-form .product-form__cart-submit');
    if (!fieldEl || !realBtn) return;

    // The visible mockup is the mobile slider on phones (`.mobile-slider-main`,
    // which carries `cstm-wrap` so the `.text-div` number overlay positions
    // against it); the desktop `.product-media-right-one` is display:none on
    // mobile. Prefer whichever is actually visible.
    function getVisibleMock() {
      var nodes = document.querySelectorAll('.mobile-slider-main, .product-media-right-one');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].offsetParent !== null && nodes[i].getBoundingClientRect().width > 0) {
          return nodes[i];
        }
      }
      return null;
    }

    var liveMock = getVisibleMock() || document.querySelector('.mobile-slider-main');
    if (!liveMock) return;

    var mediaQuery = window.matchMedia('(max-width:750px)');
    var sideCart = document.querySelector('.side-cart');
    var bar = null, mockWrap = null, built = false, aboveView = false, suppressed = false;
    var pricingSlot = null, pricingEl = null, pricingHome = null, placeholder = null, lastSig = '';

    function sideCartOpen() {
      return !!(sideCart && sideCart.classList.contains('open'));
    }

    /* Desktop version of the bar (sleeve PDP only — keyed off the desktop hero
       section being present): identical behavior/conditions to mobile, but the
       bar overlays the RIGHT buy column instead of spanning the viewport. */
    function desktopBar() {
      return !mediaQuery.matches && !!document.querySelector('.cn-pdp-hero-desktop-section');
    }

    function shouldShow() {
      return (mediaQuery.matches || desktopBar()) &&
        fieldEl.value.trim().length > 0 &&
        aboveView &&
        !suppressed &&
        !sideCartOpen();
    }

    // Moiré fix for the DESKTOP mini: the clone's product photo (~400-800px
    // source) is CSS-transform-scaled ~0.36x in one GPU pass, which aliases
    // the knit texture into moiré. Same cure as the fit gallery: resample
    // through a high-quality canvas in halving steps down to ~2x the final
    // device size, so the browser's last step is a clean 2x. Results cached
    // per source URL; a fresh crossOrigin probe avoids tainting the canvas.
    var _rsCache = {};
    function resampleMiniImg(imgEl, targetDeviceW) {
      var src = imgEl.currentSrc || imgEl.src;
      if (!src || src.indexOf('data:') === 0) return;
      var key = src + '|' + targetDeviceW;
      if (_rsCache[key]) { imgEl.src = _rsCache[key]; return; }
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var sw = probe.naturalWidth, sh = probe.naturalHeight;
          if (!sw || sw <= targetDeviceW * 1.25) return;
          var srcC = probe;
          while (sw / 2 > targetDeviceW) {
            var c = document.createElement('canvas');
            c.width = Math.round(sw / 2); c.height = Math.round(sh / 2);
            var ctx = c.getContext('2d');
            ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
            ctx.drawImage(srcC, 0, 0, c.width, c.height);
            srcC = c; sw = c.width; sh = c.height;
          }
          var out = document.createElement('canvas');
          out.width = targetDeviceW; out.height = Math.round(sh * targetDeviceW / sw);
          var octx = out.getContext('2d');
          octx.imageSmoothingEnabled = true; octx.imageSmoothingQuality = 'high';
          // Sub-pixel low-pass on the final draw: the knit texture's period is
          // ~1-2 device px at this size, so a 0.75px gaussian removes the
          // frequency that beats against the pixel grid (= the moiré) while
          // band edges stay sharp. No-op where ctx.filter is unsupported.
          try { octx.filter = 'blur(0.75px)'; } catch (e) {}
          octx.drawImage(srcC, 0, 0, out.width, out.height);
          try { octx.filter = 'none'; } catch (e) {}
          var url = out.toDataURL('image/jpeg', 0.92);
          _rsCache[key] = url;
          if (imgEl.isConnected) imgEl.src = url;
        } catch (e) {}   // tainted/decode error → original stays
      };
      probe.src = src;
    }

    // A lightweight fingerprint of what the mini actually shows — the typed number
    // and the active slide image. Used to skip needless re-clones (anti-flicker).
    function mockSig() {
      var td = liveMock.querySelector('.text-div');
      var num = td ? (td.textContent || '').trim() : '';
      var img = liveMock.querySelector('.slick-current img, .slick-active img, img');
      var src = img ? (img.currentSrc || img.src || '') : '';
      return num + '|' + src;
    }

    // Re-clone the live mockup (image slider + number overlay) into the mini
    // wrapper and scale it to SCALE. Re-cloning (vs. syncing pieces) keeps the
    // slick slider's current slide + the overlay's exact styling in step.
    function rebuildMock() {
      if (!mockWrap) return false;
      var src = getVisibleMock();
      if (src) liveMock = src;
      var rect = liveMock.getBoundingClientRect();
      if (!rect.width || !rect.height) return false;

      var clone = liveMock.cloneNode(true);
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
      // Keep only the product image slider + number overlay; drop loaders and
      // all the slider chrome (PHOTOS switcher, lifestyle gallery + thumbs,
      // wristband decoration) so the mini is a clean mockup.
      clone.querySelectorAll(
        '.sleeve-loader, .sleeve-loader-img, .gallery_switcher, ' +
        '.lifeStyle_slider_main, .lifeStyle_slider_thumbs, .main__image__right'
      ).forEach(function (el) { el.remove(); });

      // The band-color picker is a horizontal slick strip: cloned and scaled, its
      // frozen track transform drifts a few px and bleeds the neighbouring colour
      // slide into the narrow mini, clipping the band on the right. Collapse the
      // clone's slider to just the single colour currently shown in the live
      // mockup, pinned to fill the frame — no track, no bleed. Scoped to the
      // wristband (`.wristbandmain`); the sleeve's mini is left exactly as-is.
      if (document.querySelector('.wristbandmain')) {
        var liveWrap = liveMock.querySelector('.mobile-slider-wrapper');
        var cloneWrap = clone.querySelector('.mobile-slider-wrapper');
        if (liveWrap && cloneWrap) {
          var listLeft = liveWrap.getBoundingClientRect().left;
          var shownSrc = '';
          liveWrap.querySelectorAll('.mobile-slider-image img').forEach(function (im) {
            var r = im.getBoundingClientRect();
            if (r.width > 1 && Math.abs(r.left - listLeft) < 6) shownSrc = im.currentSrc || im.src;
          });
          if (!shownSrc) {
            var firstImg = liveWrap.querySelector('.mobile-slider-image img');
            if (firstImg) shownSrc = firstImg.currentSrc || firstImg.src;
          }
          if (shownSrc) {
            cloneWrap.innerHTML =
              '<img src="' + shownSrc + '" alt="" ' +
              'style="display:block;width:100%;height:100%;object-fit:contain;">';
            cloneWrap.style.visibility = 'visible';
            cloneWrap.style.opacity = '1';
          }
        }
      }

      // The wristband PDP crops its main mockup to the band — it hides the top
      // 20% of the slider (clip-path on `.mobile-slider-wrapper`) so only the
      // bottom 80% (the band + number) shows. That crop is scoped to
      // `.cn-bb-left`, so the clone (which lives under `.wristbandmain`) doesn't
      // inherit it and would otherwise render the full uncropped strip, blowing
      // out of the mini tray. Mirror the crop here: shift the clone up by the
      // hidden top portion and shorten the tray to the visible band height.
      var cropTop = document.querySelector('.wristbandmain') ? 0.20 : 0;
      var isWristDesk = !mediaQuery.matches && !!document.querySelector('.cn-pdp-hero-desktop-wrist-section');
      var scale, offsetY, frameH;
      if (mediaQuery.matches) {
        scale = SCALE;
        offsetY = -(rect.height * scale * cropTop);
        frameH = rect.height * scale * (1 - cropTop);
      } else if (isWristDesk) {
        // WRISTBAND desktop only: ZOOM 1.215x into the band, centered on the
        // image midpoint and CLAMPED to the edges so the full band always
        // shows. The zoom keeps the downsample ratio friendly (no moiré).
        frameH = 182;
        scale = (frameH / (rect.height * (1 - cropTop))) * 1.215;
        var scaledH = rect.height * scale;
        var idealTop = scaledH * 0.5 - frameH / 2;
        idealTop = Math.max(0, Math.min(idealTop, scaledH - frameH));
        offsetY = -idealTop;
      } else {
        // SLEEVE desktop: the QA'd original — full mock fitted to 182px.
        scale = Math.min(SCALE, 182 / rect.height);
        offsetY = -(rect.height * scale * cropTop);
        frameH = rect.height * scale * (1 - cropTop);
      }
      clone.style.position = 'absolute';
      clone.style.top = offsetY + 'px';
      clone.style.left = '0';
      clone.style.margin = '0';
      clone.style.width = rect.width + 'px';
      clone.style.height = rect.height + 'px';
      clone.style.transformOrigin = 'top left';
      clone.style.transform = 'scale(' + scale + ')';

      mockWrap.style.width = (rect.width * scale) + 'px';
      mockWrap.style.height = frameH + 'px';
      // WRISTBAND desktop mini only: 4px of air between the band image and the
      // tray's left edge (was flush, per Mike Jul 9)
      mockWrap.style.marginLeft = isWristDesk ? '4px' : '';
      mockWrap.innerHTML = '';
      mockWrap.appendChild(clone);
      // WRISTBAND desktop mini only: kill the transform-downscale moiré
      // (the sleeve tray stays exactly as QA'd — no resample). Resample to the
      // EXACT device-pixel size the img renders at — a 2x target still left the
      // browser one 2:1 GPU downscale, which re-aliased the knit into moiré.
      if (isWristDesk) {
        var targetW = Math.max(96, Math.round(rect.width * scale * (window.devicePixelRatio || 1)));
        clone.querySelectorAll('img').forEach(function (im) { resampleMiniImg(im, targetW); });
      }
      lastSig = mockSig();
      return true;
    }

    function buildBar() {
      if (built || document.querySelector('.cn-pinned-bar')) return;
      built = true;

      bar = document.createElement('div');
      bar.className = 'cn-pinned-bar';
      // Wristband overlay CSS is scoped to `.wristbandmain .text-div`; carry the
      // class on the bar root so the cloned overlay keeps its position.
      if (document.querySelector('.wristbandmain')) bar.classList.add('wristbandmain');

      mockWrap = document.createElement('div');
      mockWrap.className = 'cn-pinned-mock';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'btn cn-pinned-atc';
      var lbl = realBtn.querySelector('[data-add-to-cart-text]');
      function syncBtnLabel() {
        btn.textContent = ((lbl ? lbl.textContent : realBtn.textContent) || '').trim() || 'Add to Cart';
      }
      syncBtnLabel();
      // live-sync: the real label now carries the dynamic total ("Add to
      // Cart - $57.58") and changes with pack selection — mirror every change.
      if (lbl && 'MutationObserver' in window) {
        new MutationObserver(syncBtnLabel).observe(lbl, { childList: true, characterData: true, subtree: true });
      }
      btn.addEventListener('click', function () { realBtn.click(); });

      // Right column: the Single/Pair pricing cards (relocated from the PDP) sit
      // above the ATC button.
      var right = document.createElement('div');
      right.className = 'cn-pinned-right';
      pricingSlot = document.createElement('div');
      pricingSlot.className = 'cn-pinned-pricing';
      right.appendChild(pricingSlot);
      right.appendChild(btn);

      bar.appendChild(mockWrap);
      bar.appendChild(right);
      document.body.appendChild(bar);

      rebuildMock();
    }

    // Move the REAL pricing widget (the Single/Pair cards) into the bar — we move,
    // not clone, so its bound click handlers and live discount updates (which target
    // unique element IDs) keep working. It is restored to its PDP spot when the bar
    // hides. Skipped where the widget is absent or hidden (e.g. the jacket PDP).
    function movePricingToBar() {
      if (!pricingSlot) return;
      if (!pricingEl) {
        var el = document.querySelector('.tst-pricing-options');
        if (!el || el.offsetParent === null) return; // absent or hidden — leave the bar card-less
        pricingEl = el;
        pricingHome = { parent: el.parentNode, next: el.nextSibling };
        placeholder = document.createElement('div');
        placeholder.className = 'cn-pinned-pricing-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
      }
      if (pricingEl.parentNode !== pricingSlot) {
        // Leave a same-height placeholder in the PDP so pulling the widget out of the
        // page flow doesn't collapse the layout and jump the scroll position.
        placeholder.style.height = pricingEl.getBoundingClientRect().height + 'px';
        pricingHome.parent.insertBefore(placeholder, pricingEl);
        pricingSlot.appendChild(pricingEl);
      }
    }

    function restorePricing() {
      if (!pricingEl || !pricingHome || pricingEl.parentNode !== pricingSlot) return;
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.replaceChild(pricingEl, placeholder); // back in its exact spot, no shift
      } else if (pricingHome.next && pricingHome.next.parentNode === pricingHome.parent) {
        pricingHome.parent.insertBefore(pricingEl, pricingHome.next);
      } else {
        pricingHome.parent.appendChild(pricingEl);
      }
    }

    function update() {
      if (!shouldShow()) {
        if (bar) bar.classList.remove('is-visible');
        restorePricing();
        return;
      }
      buildBar();
      if (!bar) return;
      // Desktop: fit the bar to the right buy column (.product-info-main).
      bar.classList.toggle('cn-pinned-desktop', desktopBar());
      if (desktopBar()) {
        var col = document.querySelector('.product-info-main');
        if (col) {
          var cr = col.getBoundingClientRect();
          bar.style.left = cr.left + 'px';
          bar.style.width = cr.width + 'px';
          bar.style.right = 'auto';
        }
      } else {
        bar.style.left = '';
        bar.style.width = '';
        bar.style.right = '';
      }
      rebuildMock();
      movePricingToBar();
      bar.classList.add('is-visible');
    }

    // Show only once the real ATC button has scrolled ABOVE the viewport top.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (e.isIntersecting) suppressed = false; // back at the real ATC → allow the bar again
        aboveView = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      }, { threshold: 0 }).observe(realBtn);
    }

    // Side cart open/close. Opening the cart hides the bar AND keeps it gone after
    // the cart closes (so it doesn't pop back when the user returns to the PDP),
    // until the real ATC scrolls back into view and clears the suppression.
    if (sideCart && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (sideCartOpen()) suppressed = true;
        update();
      }).observe(sideCart, { attributes: true, attributeFilter: ['class'] });
    }

    // Live mockup changes (number text, color/slide swap) → re-mirror, but only when
    // the meaningful content actually changes. The slider mutates constantly (inline
    // styles, lazy-load attrs); re-cloning on every mutation made the mini flicker, so
    // skip rebuilds when the signature (number + active image) is unchanged.
    if ('MutationObserver' in window) {
      var moT = null;
      var mo = new MutationObserver(function () {
        if (!bar || !bar.classList.contains('is-visible')) return;
        if (mockSig() === lastSig) return;   // nothing visible changed — ignore
        if (moT) return;                     // a rebuild is already queued
        moT = setTimeout(function () { moT = null; rebuildMock(); }, 90);
      });
      mo.observe(liveMock, { subtree: true, childList: true, characterData: true, attributes: true });
    }

    fieldEl.addEventListener('input', update);
    mediaQuery.addEventListener('change', update);

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { rebuildMock(); update(); }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();






